import { Box, Skeleton, Typography } from "@mui/material";
import { styled, useTheme } from "@mui/system";
import { BoxUpper } from "../Shared/BoxUpper";
import { BoxBodyContainer, FlexBox, PriceComponent, RawBox } from "../Shared/Dashboard/styled";
import LinearProgress from "@mui/material/LinearProgress";
import { memo, useEffect, useState } from "react";
import { apiGetBuyFactor, apiGetSellFactor } from "../../api/dashboardApi";
import { formatPrice } from "../../helpers/dataFormat";
import { useAppDispatch, useAppSelector } from "store/store";
import RefreshIcon from "assets/icons/RefreshIcon";

const CheckoutContainer = styled(BoxBodyContainer)({
  height: "350px",
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-evenly",
});
const Checkouts = ({ title }: { title?: string }) => {
  const dispatch = useAppDispatch();
  const token = useAppSelector((x) => x.businessReducer.business?.token);
  const buyFactor = useAppSelector((x) => x.dashboardReducer.buyFactor) as CheckoutDataType;
  const sellFactor = useAppSelector((x) => x.dashboardReducer.sellFactor) as CheckoutDataType;

  // useEffect(() => {
  //   if (token) {
  //     dispatch(apiGetBuyFactor(token));
  //     dispatch(apiGetSellFactor(token));
  //   }
  // }, [token]);
  const  onClick=()=>{
    if (token) {
      dispatch(apiGetBuyFactor(token,changeLoading));
      dispatch(apiGetSellFactor(token));
    }  }
    const [isLoading, setLoading] = useState(false)
    const changeLoading = () => {
      setLoading(state => !state)
    }
  return buyFactor && sellFactor ? (
    <RawBox>
      <BoxUpper title={title} />
      <CheckoutContainer>
        <CheckoutsItems type="BUY" checkout={buyFactor} title="فاکتور خرید" />
        <CheckoutsItems type="SELL" checkout={sellFactor} title="فاکتور فروش" />
      </CheckoutContainer>
    </RawBox>
  ) : <RawBox>
  <BoxUpper title={`${title} (${0})`} />
  <Box 
    onClick={() => {
      onClick()
    }}
    sx={{
      position: 'relative',
      width: '100%', // Set your desired width
      height: 350, // Set your desired height
      display: 'flex',
      justifyContent: 'center',
      padding:"24px 15px",
      cursor: 'pointer',
      alignItems: 'center',
      // border: '1px solid #ccc', // Optional: for visual reference
    }}
  >
    <Skeleton variant="rectangular" width={"100%"} height={"100%"} />
    <Typography
      variant="h6"
      sx={{
        position: 'absolute',
        color: '#747575', // Change color based on your skeleton background
      }}
    >
        نمایش اطلاعات
          </Typography>
   <div className={`absolute bottom-[35%] ${isLoading ? "animate-spin" : ""}`}>
                  <RefreshIcon scale={0.8} />
                </div>

  </Box>
</RawBox>;
};

const StyledBoxBodyContainer = styled(BoxBodyContainer)({
  minHeight: "unset",
});
const UpperDetails = styled("div")({
  display: "flex",
  justifyContent: "space-between",
});
const CheckoutsItems = ({
  title,
  checkout,
  type,
}: {
  title: string;
  checkout: CheckoutDataType;
  type: "BUY" | "SELL";
}) => {
  const theme = useTheme();
  const total = type === "BUY" ? checkout.totalBuysPrices : checkout.totalSalesPrices;
  const paid = type === "BUY" ? checkout.paidPrices : checkout.receivedPrices;

  return (
    <RawBox>
      {/* <BoxUpper Option={BasicSelect} title={title} /> */}
      <Typography fontWeight="bold">{title}</Typography>
      <StyledBoxBodyContainer>
        <UpperDetails>
          <FlexBox>
            <Typography variant="body2" color={theme.palette.disabled.main}>
              کل &nbsp;
            </Typography>

            <PriceComponent price={formatPrice(total)} color={theme.palette.text.main} />
          </FlexBox>
          <FlexBox>
            <Typography variant="body2" color={theme.palette.disabled.main}>
              {type === "BUY" ? "پرداخت شده" : "دریافت شده"}&nbsp;
            </Typography>

            <PriceComponent price={formatPrice(paid)} color={theme.palette.text.main} />
          </FlexBox>
        </UpperDetails>
        <Box sx={{ padding: "10px" }} />
        <LinearProgress variant="determinate" value={(paid / total) * 100} />
        <Box sx={{ padding: "10px" }} />
        <UpperDetails>
          <Box sx={{ padding: "10px" }} />
          <FlexBox>
            <Typography variant="body2" color={theme.palette.text.secondary}>
              سررسید گذشته &nbsp;
            </Typography>

            <PriceComponent
              price={formatPrice(checkout.afterDueDateTotalPrices)}
              color={theme.palette.text.secondary}
            />
          </FlexBox>
        </UpperDetails>
      </StyledBoxBodyContainer>
    </RawBox>
  );
};

export default memo(Checkouts);
